import { NAME as PARENT_NAME } from '../constants';

export const NAME = `${PARENT_NAME}/PDF`;

export const REDUCER_NAME = 'pdf';

export const ROUTES = {
  ROOT: '/shipment/pdf/:sid/:iid?',
};
